import { ReactComponent as Plus } from 'assets/images/svg/icon-plus.svg'
import styles from './EventProgramm.module.scss'
import {useTranslation} from 'react-i18next'
import useSWR from 'swr'
import axios from 'axios'
import { useEffect, useState } from 'react'

const fetcher = async url => {
    const res = await axios(url)
    if (Array.isArray(res.data)) {
        return [...res.data].reverse()
    }
    return res.data
}

const selectByLang = (lang, data)=> {
    if (!data) return []
    const actual = data?.filter(item => item.active !== 0)
    return actual?.map(item => ({
        id: item.id,
        date: lang === 'ru' ? item.date_ru : item.date_en,
        text: lang === 'ru' ? item.text_ru : item.text_en
    }))
}

export const EventProgramm = ()=>  {
    const { data } = useSWR(process.env.REACT_APP_BACKEND+'/content', fetcher)
    const [currentContent, setCurrentContent] = useState([])
    const [more, setMore] = useState(false)

    const { t, i18n } = useTranslation()
    useEffect(()=> {
        setCurrentContent(selectByLang(i18n.language, data))
    }, [i18n, i18n.language, data])

    const change = ()=> setMore(!more)

    return (
        <section className={styles.section} id="prog">
            <div className="container">
                <div className={styles.box}>
                    <h2 className={styles.title}>
                        {t('event_title')}
                    </h2>
                    <div className={[styles.content, more ? styles.is_show : ''].join(' ')}>
                        {currentContent.map((data)=> (
                            <div className={styles.row}>
                                <div className={styles.date}>
                                    {data.date.split(',')[0]}
                                    <span>{data.date.split(',')[1]}</span>
                                </div>
                                <div className={styles.block} dangerouslySetInnerHTML={{__html: data.text}} />
                            </div>
                        ))}
                    </div>

                    <button className={['btn', styles.btn].join(' ')} onClick={change}>
                        <Plus />
                        {t('event_detail_btn')}
                    </button>
                </div>
            </div>
        </section>
    )
}
